import * as actionTypes from 'constants/ActionTypes';

export function getCompanies() {
    return {
        type: actionTypes.GET_COMPANIES.REQUEST,
    };
}



// WEBPACK FOOTER //
// ./app/actions/companies.js